import React from 'react';
import './HowItWorks.css';

function HowItWorks() {
  const steps = [
    {
      number: '1',
      icon: '📝',
      title: 'Crear Orden',
      description: 'Registra la solicitud del cliente con todos los detalles necesarios'
    },
    {
      number: '2',
      icon: '👷',
      title: 'Asignar Técnico',
      description: 'Selecciona el técnico disponible y envíale la orden automáticamente'
    },
    {
      number: '3',
      icon: '🚗',
      title: 'Seguimiento del Trabajo',
      description: 'Monitorea en tiempo real el progreso y ubicación del técnico'
    },
    {
      number: '4',
      icon: '✅',
      title: 'Completar y Facturar',
      description: 'El técnico cierra el trabajo y generas la factura al instante'
    }
  ];

  return (
    <section className="how-it-works section">
      <div className="container">
        <h2 className="section-title">¿Cómo funciona?</h2>
        <p className="section-subtitle">
          En solo 4 pasos simples, gestiona todo el ciclo de servicio
        </p>
        <div className="steps-container">
          {steps.map((step, index) => (
            <div key={index} className="step">
              <div className="step-number">{step.number}</div>
              <div className="step-icon">{step.icon}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-description">{step.description}</p>
              {index < steps.length - 1 && <div className="step-arrow">→</div>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default HowItWorks;
